import classNames from 'classnames';
import { useState } from 'react';

import { TemplateClassNames } from '../../../types/template-layouts';
import { LanguagesAbbr } from '../../../types/working-model';
import TranslateLangs from '../../../utils/translate-langs.json';
import { useScreenMediaQuery } from '../../../utils/use-screen-media-query';
import NewDropdown from '../dropdown/new-dropdown';
import { TypographyItem } from '../typography-item/typography-item';
import './language-dropdown.scss';

export interface ILang {
	code: LanguagesAbbr;
	label: string;
}

export const ALL_LANGS: ILang[] = TranslateLangs as any;

interface LanguageDropdownProps {
	currentLanguageCode?: LanguagesAbbr;
	onLanguageChange?: (lang: LanguagesAbbr) => void;
	languages?: LanguagesAbbr[];
	className?: string;
	template?: TemplateClassNames;
	verticalPosition?: 'top' | 'bottom';
	edge?: 'left' | 'right';
	top?: boolean;
}

export const LanguageDropdown = ({
	currentLanguageCode,
	onLanguageChange,
	className,
	template,
	languages,
	edge = 'right',
	top = false
}: LanguageDropdownProps): JSX.Element => {
	const { isLessThan768 } = useScreenMediaQuery();
	const allLanguages: ILang[] = languages
		? (languages
			.map((l) => ALL_LANGS.find((f) => f.code === l))
			.filter((f) => f) as any)
		: ALL_LANGS;

	const [code, setCode] = useState<LanguagesAbbr>(currentLanguageCode || 'en');

	return (
		<NewDropdown
			className={classNames('language-dropdown', className, template)}
			popupClassName={top ? 'menu-top-placement' : ''}
			edge={edge}
			renderTitle={() => code}
			template={template}
			isNoScroll={isLessThan768}
		>
			<TypographyItem
				className={classNames('language-dropdown-title', {
					'evt-heading-3': template === TemplateClassNames.Apollo,
					'evt-heading-4': template !== TemplateClassNames.Apollo,
				})}
			>
				Select Language
			</TypographyItem>
			<div className="language-list">
				{allLanguages.map((lang) => (
					<div
						className={classNames('language-list-item', {
							selected: lang.code === currentLanguageCode,
						})}
						onClick={() => {
							setCode(lang.code);
							onLanguageChange && onLanguageChange(lang.code);
						}}
						key={lang.code}
					>
						{lang.label}
					</div>
				))}
			</div>
		</NewDropdown>
	);
};
